package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CalendarImportCommitRequest(
    @SerialName("session_id") val sessionId: String,
    val publish: Boolean = false
)
